import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Full Screen"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-full-screen',
    templateUrl: './icon-full-screen.component.html',
    styleUrls: ['./icon-full-screen.component.scss'],
    standalone: false
})
export class IconFullScreenComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
